import React, { useState, useEffect } from 'react';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const menuItems = [
    {
      title: 'Giới thiệu',
      submenu: [
        { title: 'Công ty CP SX & TM G-Nine Việt Nam', link: '#about' },
        { title: 'Gnine Solar', link: '#solar' },
        { title: 'Gnine Farm', link: '#farm' },
        { title: 'Ban lãnh đạo', link: '#leadership' }
      ]
    },
    {
      title: 'Dự án điện mặt trời',
      submenu: [
        { title: 'Dự án Công Nghiệp', link: '#industrial' },
        { title: 'Dự án Dân Dụng', link: '#residential' }
      ]
    },
    { title: 'Thiết bị vật tư', link: '#equipment' },
    { title: 'Bảng giá', link: '#pricing' },
    {
      title: 'Truyền thông',
      submenu: [
        { title: 'Tin tức', link: '#news' },
        { title: 'Kinh nghiệm hay', link: '#tips' }
      ]
    },
    { title: 'Liên Hệ', link: '#contact' }
  ];

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <nav className="navbar">
          <a href="#home" className="logo">
            <span className="logo-text">GNINE</span>
            <span className="logo-highlight">GROUP</span>
          </a>

          <ul className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
            {menuItems.map((item, index) => (
              <li 
                key={index} 
                className={`nav-item ${item.submenu ? 'has-submenu' : ''}`}
              >
                <a 
                  href={item.link || '#'} 
                  className="nav-link"
                  onClick={!item.submenu ? closeMobileMenu : undefined}
                >
                  {item.title}
                  {item.submenu && <i className="fas fa-chevron-down"></i>}
                </a>
                {item.submenu && (
                  <ul className="submenu">
                    {item.submenu.map((subItem, subIndex) => (
                      <li key={subIndex}>
                        <a href={subItem.link} onClick={closeMobileMenu}>
                          {subItem.title}
                        </a>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>

          <div className="nav-actions">
            <a href="tel:0989786995" className="hotline">
              <i className="fas fa-phone-alt"></i>
              <span>0989.786.995 - 0983.913.951</span>
            </a>
            <button className="btn-cta">Đăng ký tư vấn</button>
          </div>

          <button 
            className={`mobile-menu-btn ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;